import { render, staticRenderFns } from "./WebConfiguration.vue?vue&type=template&id=1905e2dc&"
import script from "./WebConfiguration.vue?vue&type=script&lang=js&"
export * from "./WebConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports